import i18n from '@i18next/i18n';

import ICON_VER_BAR1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_vertical_01l_66.svg';
import ICON_VER_BAR2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_vertical_02l_66.svg';
import ICON_VER_BAR3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_vertical_03l_66.svg';
import ICON_VER_BAR4 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_vertical_04l_66.svg';
import ICON_VER_BAR6 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_vertical_06l_66.svg';
import ICON_VER_BAR8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_vertical_08l_66.svg';
import ICON_VER_BAR_STACK1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_vertical_01l_66.svg';
import ICON_VER_BAR_STACK2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_vertical_02l_66.svg';
import ICON_VER_BAR_STACK3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_vertical_03l_66.svg';
import ICON_VER_BAR_STACK6 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_vertical_06l_66.svg';
import ICON_VER_BAR_STACK8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_vertical_08l_66.svg';
import ICON_VER_BAR_STACK9 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_vertical_09l_66.svg';
import ICON_HOZ_BAR1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_horizontal_01l_66.svg';
import ICON_HOZ_BAR2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_horizontal_02l_66.svg';
import ICON_HOZ_BAR3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_horizontal_03l_66.svg';
import ICON_HOZ_BAR6 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_horizontal_06l_66.svg';
import ICON_HOZ_BAR8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_horizontal_08l_66.svg';
import ICON_HOZ_BAR9 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_bargraph_horizontal_09l_66.svg';
import ICON_HOZ_BAR_STACK1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_horizontal_01l_66.svg';
import ICON_HOZ_BAR_STACK2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_horizontal_02l_66.svg';
import ICON_HOZ_BAR_STACK3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_horizontal_03l_66.svg';
import ICON_HOZ_BAR_STACK7 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_horizontal_07l_66.svg';
import ICON_HOZ_BAR_STACK8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_horizontal_08l_66.svg';
import ICON_HOZ_BAR_STACK9 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stackedbar_horizontal_09l_66.svg';
import ICON_LINE1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_linechart_01l_66.svg';
import ICON_LINE2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_linechart_02l_66.svg';
import ICON_LINE3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_linechart_03l_66.svg';
import ICON_LINE7 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_linechart_07l_66.svg';
import ICON_LINE8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_linechart_08l_66.svg';
import ICON_LINE10 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_linechart_10l_66.svg';
import ICON_PIE1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_piechart_01l_66.svg';
import ICON_PIE2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_piechart_02l_66.svg';
import ICON_PIE3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_piechart_03l_66.svg';
import ICON_PIE4 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_piechart_04l_66.svg';
import ICON_PIE5 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_piechart_05l_66.svg';
import ICON_PIE6 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_piechart_06l_66.svg';
import ICON_DOUGHNUT1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_doughnutchart_01l_66.svg';
import ICON_DOUGHNUT2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_doughnutchart_02l_66.svg';
import ICON_DOUGHNUT3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_doughnutchart_03l_66.svg';
import ICON_DOUGHNUT4 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_doughnutchart_04l_66.svg';
import ICON_DOUGHNUT5 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_doughnutchart_05l_66.svg';
import ICON_DOUGHNUT6 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_doughnutchart_06l_66.svg';
import ICON_BUBBLE1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_scatterdiagram_01l_66.svg';
import ICON_BUBBLE2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_scatterdiagram_02l_66.svg';
import ICON_BUBBLE3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_scatterdiagram_03l_66.svg';
import ICON_BUBBLE7 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_scatterdiagram_07l_66.svg';
import ICON_BUBBLE8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_scatterdiagram_08l_66.svg';
import ICON_BUBBLE9 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_scatterdiagram_09l_66.svg';
import ICON_RADAR1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_radarmap_01l_66.svg';
import ICON_RADAR2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_radarmap_02l_66.svg';
import ICON_RADAR3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_radarmap_03l_66.svg';
import ICON_RADAR4 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_radarmap_04l_66.svg';
import ICON_AREA1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_areagraph_01l_66.svg';
import ICON_AREA2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_areagraph_02l_66.svg';
import ICON_AREA3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_areagraph_03l_66.svg';
import ICON_AREA4 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_areagraph_04l_66.svg';
import ICON_AREA7 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_areagraph_07l_66.svg';
import ICON_AREA8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_areagraph_08l_66.svg';
import ICON_STOCK1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stockchart_01l_66.svg';
import ICON_STOCK2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stockchart_02l_66.svg';
import ICON_STOCK3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stockchart_03l_66.svg';
import ICON_STOCK4 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stockchart_04l_66.svg';
import ICON_STOCK5 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stockchart_05l_66.svg';
import ICON_STOCK6 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_stockchart_06l_66.svg';
import ICON_OF_PIE1 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_pieofpiechart_01l_66.svg';
import ICON_OF_PIE2 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_pieofpiechart_02l_66.svg';
import ICON_OF_PIE3 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_pieofpiechart_03l_66.svg';
import ICON_OF_PIE6 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_pieofpiechart_06l_66.svg';
import ICON_OF_PIE7 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_pieofpiechart_07l_66.svg';
import ICON_OF_PIE8 from '@tencent/docs-design-resources/image/desktop/svg/chat/chat_fastlayout_pieofpiechart_08l_66.svg';
import ICON_OF_BAR1 from '@tencent/docs-design-resources/icon/desktop/svg/chart_pie_chart_rectangle_a_66.svg';
import ICON_OF_BAR2 from '@tencent/docs-design-resources/icon/desktop/svg/chart_pie_chart_rectangle_b_66.svg';
import ICON_OF_BAR3 from '@tencent/docs-design-resources/icon/desktop/svg/chart_pie_chart_rectangle_c_66.svg';
import ICON_OF_BAR6 from '@tencent/docs-design-resources/icon/desktop/svg/chart_pie_chart_rectangle_d_66.svg';
import ICON_OF_BAR8 from '@tencent/docs-design-resources/icon/desktop/svg/chart_pie_chart_rectangle_f_66.svg';

import { STBarDir, STDLblPos, STLegendPos, SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { OfPieType } from '@tencent/chart/lib/chart-ui/interface';

/**
 * 快速布局配置项声明
 */
export interface IChartLayoutConfig {
    /**
     * 是否显示图表标题
     */
    showTitle?: boolean;

    /**
     * 是否显示图例
     */
    showLegend?: boolean;

    /**
     * 图例位置。showLegend为true时，会读取图例位置，默认为bottom
     */
    legendPos?: STLegendPos;

    /**
     * 是否显示横纵坐标轴
     * 注意：显示时只显示主轴，移除时会移除主轴和次轴
     */
    showXAxes?: boolean;
    showYAxes?: boolean;

    /**
     * 是否显示横纵坐标轴标题(主轴)，不影响次轴标题
     */
    showXAxesTitle?: boolean;
    showYAxesTitle?: boolean;

    /**
     * 是否显示X轴主次网格线
     */
    showXMajorGridLine?: boolean;
    showXMinorGridLine?: boolean;
    /**
     * 是否显示Y轴主次网格线
     */
    showYMajorGridLine?: boolean;
    showYMinorGridLine?: boolean;

    /**
     * 是否显示数据标签
     */
    showLabel?: boolean;
    /**
     * 是否显示最后一个类别的数据标签，和showLastSerLabel互斥
     */
    showLastCateLabel?: boolean;
    /**
     * 是否显示最后一个系列的数据标签，和showLastCateLabel互斥
     */
    showLastSerLabel?: boolean;
    /**
     * 数据标签的值组成
     */
    showVal?: boolean;
    showCategoryName?: boolean;
    showPercent?: boolean;
    showSeriesName?: boolean;
    /**
     * 数据标签位置
     */
    labelPos?: STDLblPos;

    /**
     * 是否显示趋势线(第一个系列)
     */
    showTrendLine?: boolean;
    /**
     * 是否显示趋势线的公式
     */
    showFormula?: boolean;

    /**
     * 是否显示垂直线
     */
    showDropLines?: boolean;

    /**
     * 是否显示高低线
     */
    showHighLowLines?: boolean;

    /**
     * 子母图&复合图，第二个图形等于和大于第一个饼图
     */
    isSecondPieEqual?: boolean;
    isSecondPieBigger?: boolean;

    //  柱形图属性
    overlap?: number;
    gapWidth?: number;
}

/**
 * 快速布局每一项的布局信息
 */
export interface IChartFastLayoutItem {
    /**
     * 图表类型
     */
    type: SubChartType;

    /**
     * 图表子类型，用来区分同一种图表，拥有不容类型的layout，比如子母图
     */
    subType: string;

    /**
     * 布局类型
     */
    layouts: IChartUIFastLayout [];
}

export interface IChartUIFastLayout {
    title: string,
    icon: string,
    config: IChartLayoutConfig,
}

/**
 * 不同图表的快速布局配置项
 */
export const FAST_LAYOUT_CONFIG: IChartFastLayoutItem[] = [
    // 柱形图配置项
    {
        type: SubChartType.BarChart,
        subType: `${STBarDir.col}`,
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_VER_BAR1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                    overlap: 0,
                    gapWidth: 150,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_VER_BAR2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.outEnd,
                    showVal: true,
                    showXAxes: true,
                    overlap: -25,
                    gapWidth: 150,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_VER_BAR3,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: -25,
                    gapWidth: 75,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_VER_BAR4,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showLabel: true,
                    labelPos: STDLblPos.outEnd,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                    overlap: 0,
                    gapWidth: 75,
                },
            },
            {
                title: i18n.t('布局5'),
                icon: ICON_VER_BAR6,
                config: {
                    showTitle: true,
                    showYAxesTitle: true,
                    showLastCateLabel: true,
                    labelPos: STDLblPos.outEnd,
                    showVal: true,
                    showSeriesName: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: 0,
                    gapWidth: 150,
                },
            },
            {
                title: i18n.t('布局6'),
                icon: ICON_VER_BAR8,
                config: {
                    showTitle: true,
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    overlap: 0,
                    gapWidth: 0,
                },
            },
        ],
    },
    // 堆积柱形图配置项
    {
        type: SubChartType.BarChart,
        subType: `${STBarDir.col}-stack`,
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_VER_BAR_STACK1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                    overlap: 100,
                    gapWidth: 55,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_VER_BAR_STACK2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.ctr,
                    showVal: true,
                    showXAxes: true,
                    overlap: 100,
                    gapWidth: 95,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_VER_BAR_STACK3,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                    overlap: 100,
                    gapWidth: 75,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_VER_BAR_STACK6,
                config: {
                    showTitle: true,
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showLastCateLabel: true,
                    labelPos: STDLblPos.ctr,
                    showVal: true,
                    showSeriesName: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: 100,
                    gapWidth: 55,
                },
            },
            // {
            //     title: i18n.t('布局5'),
            //     icon: ICON_VER_BAR_STACK8,
            //     config: {
            //         showTitle: true,
            //         showLegend: true,
            //         legendPos: STLegendPos.r,
            //         showXAxesTitle: true,
            //         showYAxesTitle: true,
            //         showXAxes: true,
            //         showYAxes: true,
            //         showYMajorGridLine: true,
            //         // todo 系列线
            //     },
            // },
            {
                title: i18n.t('布局5'),
                icon: ICON_VER_BAR_STACK9,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLastSerLabel: true,
                    labelPos: STDLblPos.inEnd,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: 0,
                    gapWidth: 300,
                },
            },
        ],
    },
    // 条形图配置项
    {
        type: SubChartType.BarChart,
        subType: `${STBarDir.bar}`,
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_HOZ_BAR1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，X轴
                    overlap: 0,
                    gapWidth: 150,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_HOZ_BAR2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.outEnd,
                    showVal: true,
                    showXAxes: true,
                    overlap: -25,
                    gapWidth: 150,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_HOZ_BAR3,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: -25,
                    gapWidth: 75,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_HOZ_BAR6,
                config: {
                    showTitle: true,
                    showYAxesTitle: true,
                    showLastCateLabel: true,
                    labelPos: STDLblPos.outEnd,
                    showVal: true,
                    showSeriesName: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: 0,
                    gapWidth: 150,
                },
            },
            {
                title: i18n.t('布局5'),
                icon: ICON_HOZ_BAR8,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: 0,
                    gapWidth: 150,
                },
            },
            {
                title: i18n.t('布局6'),
                icon: ICON_HOZ_BAR9,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLastSerLabel: true,
                    labelPos: STDLblPos.inEnd,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，X轴
                    overlap: 40,
                    gapWidth: 75,
                },
            },
        ],
    },
    // 堆积条形图配置项
    {
        type: SubChartType.BarChart,
        subType: `${STBarDir.bar}-stack`,
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_HOZ_BAR_STACK1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，X轴
                    overlap: 100,
                    gapWidth: 55,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_HOZ_BAR_STACK2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.ctr,
                    showVal: true,
                    showXAxes: true,
                    overlap: 100,
                    gapWidth: 95,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_HOZ_BAR_STACK3,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: 100,
                    gapWidth: 75,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_HOZ_BAR_STACK7,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    showYMinorGridLine: true,
                    overlap: 100,
                    gapWidth: 75,
                },
            },
            // {
            //     title: i18n.t('布局8'),
            //     icon: ICON_HOZ_BAR_STACK8,
            //     config: {
            //         showTitle: true,
            //         showLegend: true,
            //         legendPos: STLegendPos.r,
            //         showXAxesTitle: true,
            //         showYAxesTitle: true,
            //         showXAxes: true,
            //         showYAxes: true,
            //         showYMajorGridLine: true,
            //         // todo 系列线
            //     },
            // },
            {
                title: i18n.t('布局5'),
                icon: ICON_HOZ_BAR_STACK9,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLastSerLabel: true,
                    labelPos: STDLblPos.inEnd,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                    overlap: 0,
                    gapWidth: 300,
                },
            },
        ],
    },
    // 折线图配置项
    {
        type: SubChartType.LineChart,
        subType: '',
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_LINE1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showYAxesTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_LINE2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.r,
                    showVal: true,
                    showXAxes: true,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_LINE3,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,
                },
            },
            // {
            //     title: i18n.t('布局6'),
            //     icon: ICON_LINE7,
            //     config: {
            //         // todo 垂直线
            //     },
            // },
            {
                title: i18n.t('布局4'),
                icon: ICON_LINE8,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showLabel: true,
                    labelPos: STDLblPos.ctr,
                    showVal: true,
                    showXAxes: true,
                },
            },
            // {
            //     title: i18n.t('布局11'),
            //     icon: ICON_LINE10,
            //     config: {
            //         // todo 高低线
            //     },
            // },
        ],
    },
    // 饼图配置项
    {
        type: SubChartType.PieChart,
        subType: '',
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_PIE1,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                    showCategoryName: true,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_PIE2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_PIE3,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.b,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_PIE4,
                config: {
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showVal: true,
                    showCategoryName: true,
                },
            },
            {
                title: i18n.t('布局5'),
                icon: ICON_PIE5,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showCategoryName: true,
                },
            },
            {
                title: i18n.t('布局6'),
                icon: ICON_PIE6,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                },
            },
        ],
    },
    // 圆环图配置项
    {
        type: SubChartType.DoughnutChart,
        subType: '',
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_DOUGHNUT1,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                    showCategoryName: true,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_DOUGHNUT2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_DOUGHNUT3,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.b,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_DOUGHNUT4,
                config: {
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showVal: true,
                    showCategoryName: true,
                },
            },
            {
                title: i18n.t('布局5'),
                icon: ICON_DOUGHNUT5,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showCategoryName: true,
                },
            },
            {
                title: i18n.t('布局6'),
                icon: ICON_DOUGHNUT6,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                },
            },
        ],
    },
    // 散点&气泡图
    {
        type: SubChartType.BubbleChart,
        subType: '',
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_BUBBLE1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_BUBBLE2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.r,
                    showVal: true,
                    showXAxes: true,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_BUBBLE3,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showTrendLine: true,
                    showXAxes: true,
                    showYAxes: true,
                    showXMajorGridLine: true,
                    showXMinorGridLine: true,
                    showYMajorGridLine: true,
                    showYMinorGridLine: true,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_BUBBLE7,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLabel: true,
                    showVal: true,
                    showCategoryName: true,
                    labelPos: STDLblPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showXMajorGridLine: true,
                    showYMajorGridLine: true,
                },
            },
            {
                title: i18n.t('布局5'),
                icon: ICON_BUBBLE8,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showXAxes: true,
                    showYAxes: true,
                    showXMajorGridLine: true,
                    showYMajorGridLine: true,
                },
            },
            // {
            //     title: i18n.t('布局9'),
            //     icon: ICON_BUBBLE9,
            //     config: {
            //         // todo 公式
            //     },
            // },
        ],
    },
    // 雷达图配置项
    {
        type: SubChartType.RadarChart,
        subType: '',
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_RADAR1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_RADAR2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_RADAR3,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                    showYMinorGridLine: true,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_RADAR4,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                    showYMinorGridLine: true,
                },
            },
        ],
    },
    // 面积图配置项
    {
        type: SubChartType.AreaChart,
        subType: '',
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_AREA1,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showYAxesTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_AREA2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_AREA3,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_AREA4,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.b,
                    showLabel: true,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                },
            },
            // {
            //     title: i18n.t('布局7'),
            //     icon: ICON_AREA7,
            //     config: {
            //         // todo 垂直线
            //     },
            // },
            {
                title: i18n.t('布局5'),
                icon: ICON_AREA8,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
        ],
    },
    // 股价图配置项
    {
        type: SubChartType.StockChart,
        subType: '',
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_STOCK1,
                config: {
                    showTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_STOCK2,
                config: {
                    showLabel: true,
                    labelPos: STDLblPos.r,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_STOCK3,
                config: {
                    showTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
            // {
            //     title: i18n.t('布局4'),
            //     icon: ICON_STOCK4,
            //     config: {
            //         // todo: 数据表
            //     },
            // },
            {
                title: i18n.t('布局4'),
                icon: ICON_STOCK5,
                config: {
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                    showYMinorGridLine: true,
                },
            },
            {
                title: i18n.t('布局5'),
                icon: ICON_STOCK6,
                config: {
                    showTitle: true,
                    showXAxesTitle: true,
                    showYAxesTitle: true,
                    showLastCateLabel: true,
                    labelPos: STDLblPos.r,
                    showVal: true,
                    showXAxes: true,
                    showYAxes: true,
                    showYMajorGridLine: true,  // 主网格线，Y轴
                },
            },
        ],
    },
    // 子母图配置项
    {
        type: SubChartType.OfPieChart,
        subType: `${OfPieType.pie}`,
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_OF_PIE1,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showCategoryName: true,
                    showPercent: true,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_OF_PIE2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_OF_PIE3,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.b,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_OF_PIE6,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLabel: true,
                    showPercent: true,
                    labelPos: STDLblPos.bestFit,
                },
            },
            {
                title: i18n.t('布局5'),
                icon: ICON_OF_PIE7,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                    showCategoryName: true,
                    isSecondPieBigger: true,
                },
            },
            {
                title: i18n.t('布局6'),
                icon: ICON_OF_PIE8,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                    showCategoryName: true,
                    isSecondPieEqual: true,
                },
            },
        ],
    },
    {
        type: SubChartType.OfPieChart,
        subType: `${OfPieType.bar}`,
        layouts: [
            {
                title: i18n.t('布局1'),
                icon: ICON_OF_BAR1,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showCategoryName: true,
                    showPercent: true,
                },
            },
            {
                title: i18n.t('布局2'),
                icon: ICON_OF_BAR2,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.t,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                },
            },
            {
                title: i18n.t('布局3'),
                icon: ICON_OF_BAR3,
                config: {
                    showLegend: true,
                    legendPos: STLegendPos.b,
                },
            },
            {
                title: i18n.t('布局4'),
                icon: ICON_OF_BAR6,
                config: {
                    showTitle: true,
                    showLegend: true,
                    legendPos: STLegendPos.r,
                    showLabel: true,
                    showPercent: true,
                    labelPos: STDLblPos.bestFit,
                },
            },
            {
                title: i18n.t('布局6'),
                icon: ICON_OF_BAR8,
                config: {
                    showTitle: true,
                    showLabel: true,
                    labelPos: STDLblPos.bestFit,
                    showPercent: true,
                    showCategoryName: true,
                    isSecondPieEqual: true,
                },
            },
        ],
    },
];
